import { createFeatureSelector } from '@ngrx/store';

import { MODULE_KEY } from '../../constants';
import { PurchaseServiceState } from '../reducers';

export const selectBuyBackMakeUpModuleState = createFeatureSelector<PurchaseServiceState>(MODULE_KEY);
